var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumerUnit01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.65,14.19L2.09,1.63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.12,
    y: -0.97,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.1404 8.2358)",
    className: "st2",
    width: 0.5,
    height: 17.76
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.09,14.19L14.65,1.63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.51,
    y: 7.66,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.1404 8.2358)",
    className: "st2",
    width: 17.76,
    height: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerUnit01);
export default __webpack_public_path__ + "static/media/ConsumerUnit-01.61f493bfaf14daf72f2da88f9286e3e7.svg";
export { ForwardRef as ReactComponent };